import { TariffCodeConstant } from "presentation/constant/TariffCode/TariffCodeConstant"
import { useTariffCodeByCompanyVM } from "presentation/hook/TariffCodeByCompany/useTariffCodeByCompanyVM"
import { useMessageBarVM } from "presentation/hook/useMessageBar"
import { useANAInfoTracked } from "presentation/store/ANAInfo"
import { useTariffCodeByCompanyTracked } from "presentation/store/TariffCodeByCompany/TariffCodeByCompanyProvider"
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer"
import { NbisCommonField } from "presentation/view/components/NbisCommonField"
import { useCallback, useMemo } from "react"
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core"
import { SidebarCaption, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled"

export const TariffCodeByCompanyDetailFormPanel = () => {
    const [tariffCodeByCompanyState] = useTariffCodeByCompanyTracked();
    const tariffCodeByCompanyVM = useTariffCodeByCompanyVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, detailState, dynamicOptions, isLoading } = tariffCodeByCompanyState;
    const { isAdd, isEditable, isRead, isSaveClicked, allFormState, currentSelectItem, editingItem } = detailState;
    const TARIFF_CODE_CONSTANT = TariffCodeConstant.Table;
    // const [isLoading, setIsLoading] = useState(false);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit, allowUpdate } = anaInfoState;

    const currentEntity = isRead ? currentSelectItem : editingItem;

    const memoParentTariffCodeOptions = useMemo(() => {
        return currentEntity?.parentTariffType
            ? dynamicOptions.parentTariffCodeDropdownOptions[currentEntity?.parentTariffType]
            : [];
    }, [currentEntity?.parentTariffType, dynamicOptions.parentTariffCodeDropdownOptions]);



    const handleCancelClick = () => {
        tariffCodeByCompanyVM.onDetailEditCancel();
    }

    const handleSaveClick = useCallback(async () => {
        if ((!currentEntity.parentTariffCode && currentEntity.parentTariffType) || (currentEntity.parentTariffCode && !currentEntity.parentTariffType)) {
            messageBarVM.showError("The Parent Tariff Type and Parent Tariff Code must be inputted together.");
            return;
        }
        if (operatingUnit !== 'SAPT' && operatingUnit !== 'KICT' && currentEntity.parentTariffType &&
            currentEntity.parentTariffType !== currentEntity.tariffType) {
            messageBarVM.showError("Tariff Type should same as Parent Tariff Type.");
            return;
        }
        tariffCodeByCompanyVM.onShowLoading();
        tariffCodeByCompanyVM.onDetailSaveClicked();
        const res = await tariffCodeByCompanyVM.onDetailSave(editingItem);
        tariffCodeByCompanyVM.onHideLoading();
        if (res) {
            messageBarVM.showError(res["warningMessage"]);
        } else {
            tariffCodeByCompanyVM.onSearchCompanyTariffCode(currentSelectedRow)
        }

    }, [currentSelectedRow, editingItem, messageBarVM, tariffCodeByCompanyVM, currentEntity, operatingUnit])

    const memoSeq = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEntity?.seq?.toString() || ''}
                //fieldValue={currentEntity?.seq?.toString()}
                fieldLabel={TARIFF_CODE_CONSTANT.SEQ}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'seq'}
                isShowMissingError={false}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [TARIFF_CODE_CONSTANT.SEQ, currentEntity?.seq, isSaveClicked])


    const memoTarType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.tariffType || ''}
                fieldValue={currentEntity?.tariffType}
                fieldLabel={TARIFF_CODE_CONSTANT.TARIFF_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                isShowMissingError={true}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [allFormState, currentEntity?.tariffType, TARIFF_CODE_CONSTANT.TARIFF_TYPE, isSaveClicked])

    const memoTarCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.tariffCode || ''}
                fieldValue={currentEntity?.tariffCode}
                fieldLabel={TARIFF_CODE_CONSTANT.TARIFF_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'tariffCode'}
                isShowMissingError={true}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [TARIFF_CODE_CONSTANT.TARIFF_CODE, allFormState, currentEntity?.tariffCode, isSaveClicked])

    const memoTarCodeDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.tariffCodeDesc || ''}
                fieldValue={currentEntity?.tariffCodeDesc}
                fieldLabel={TARIFF_CODE_CONSTANT.TARIFF_CODE_DESC}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'tariffCodeDesc'}
                isShowMissingError={true}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [TARIFF_CODE_CONSTANT.TARIFF_CODE_DESC, allFormState, currentEntity?.tariffCodeDesc, isSaveClicked])

    const memoTarCodeDescOther = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEntity?.tariffCodeDescOther || ''}
                fieldValue={currentEntity?.tariffCodeDescOther}
                fieldLabel={TARIFF_CODE_CONSTANT.TARIFF_CODE_DESCOTHER}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'tariffCodeDescOther'}
                isShowMissingError={false}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [TARIFF_CODE_CONSTANT.TARIFF_CODE_DESCOTHER, currentEntity?.tariffCodeDescOther, isSaveClicked])

    const memoParentTarType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={isRead || !allowUpdate}
                isShowOptional={true}
                readOnlyValue={currentEntity?.parentTariffType || ''}
                fieldValue={currentEntity?.parentTariffType || ''}
                fieldLabel={TARIFF_CODE_CONSTANT.PARENT_TARIFF_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'parentTariffType'}
                isShowMissingError={false}
                maxLength={60}
                options={dynamicOptions.parentTariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffCodeByCompanyVM.onDetailFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_CODE_CONSTANT.PARENT_TARIFF_TYPE, currentEntity?.parentTariffType, isSaveClicked, isRead, dynamicOptions.parentTariffTypeDropdownOptions, tariffCodeByCompanyVM, allowUpdate])

    const memoParentTarCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={isRead || !allowUpdate}
                isShowOptional={true}
                readOnlyValue={currentEntity?.parentTariffCode || ''}
                fieldValue={currentEntity?.parentTariffCode || ''}
                fieldLabel={TARIFF_CODE_CONSTANT.PARENT_TARIFF_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'parentTariffCode'}
                isShowMissingError={false}
                maxLength={60}
                options={memoParentTariffCodeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffCodeByCompanyVM.onDetailFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_CODE_CONSTANT.PARENT_TARIFF_CODE, currentEntity?.parentTariffCode, isRead, isSaveClicked, memoParentTariffCodeOptions, tariffCodeByCompanyVM, allowUpdate])


    return (
        <div className='side-form-content-wrapper' style={{ position: 'relative', height: "100vh-128px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            <SidebarTitle>{currentEntity.tariffType + '/' + currentEntity.tariffCode}</SidebarTitle>
                            {(isAdd || (isEditable && !isRead)) && <SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                        </SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoSeq}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTarType}
                            {memoTarCode}
                        </CriteriaItemContainer>


                        <CriteriaItemContainer>
                            {memoParentTarType}
                            {memoParentTarCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTarCodeDesc}
                            {memoTarCodeDescOther}
                        </CriteriaItemContainer>
                    </div>
                </div>
                <div className='im-charge-data-search-criteria-buttons' >
                    {
                        <>
                            <HPHButton label={isRead ? 'Close' : 'Cancel'} size={'Small'} theme={'Secondary'} onClick={handleCancelClick} />
                            {allowUpdate && !isRead && <HPHButton label={isAdd ? 'Add' : "Update"} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />}
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

